import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { CompanyInfo } from '../classes/company-info';

@Injectable()
export class CompanyInfoService {

  constructor(private http: Http) { }

  saveCompanyInfo(info: CompanyInfo) {
    let data: any = { user: info };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(environment.createCompanyUrl, data, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/company-info.service.ts